import React, { useState, useEffect, Fragment, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";

import { makeStyles } from "@mui/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";
// core components
import { Payment } from "@mui/icons-material";
import clsx from "clsx";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import Moment from "moment";
import {
  Card,
  CardContent,
  Alert,
  Grid,
  Box,
  DialogContent,
  DialogActions,
  Dialog,
} from "@mui/material";

//import RefundedPay from "views/dialog/RefundedPay";

import {
  blackColor,
  cardBodyStyle,
  ButtonExit,
} from "components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

// Crea un tema personalizado
const theme = createTheme({
  components: {
    MuiTablePagination: {
      styleOverrides: {
        displayedRows: {
          color: "black", // Cambia el color del texto a negro
        },
      },
    },
  },
});

export default function ViewsTrasactionsPayment(props) {
  const classes = useStyles();

  const { UserAuth } = useContext(UrlServicesContext);

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const [state] = useState({
    columns: [
      {
        headerName: "Referencia",
        field: "reference",
        width: 100,
        // headerAlign: "center",
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        renderCell: (params) => {
          return params.value;
        },
        sortable: false,
        hideable: false,
        align: "center",
      },
      {
        headerName: "Estado",
        field: "status",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          const text =
            params.value === 1
              ? "PAGADO"
              : params.value === 0
                ? "RECHAZADO"
                : params.value === 3 || params.value === 99
                  ? "PENDIENTE"
                  : "REEMBOLSO";
          const color =
            params.value === 1
              ? "green"
              : params.value === 0
                ? "red"
                : params.value === 3 || params.value === 99
                  ? "orange"
                  : blackColor;

          let refunded = params.row.responseTransaction
            ? params.row.responseTransaction.payment && params.value === 1
              ? params.row.responseTransaction.payment[0].refunded
              : false
            : false;

          return (
            <>
              <b style={{ color: color, fontSize: 10 }}>
                {refunded ? "REEMBOLSO" : text}
              </b>
            </>
          );
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 100,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Detalle",
        field: "responseTransaction",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          const color = params.row.status === 1 ? "green" : "";
          return (
            <b style={{ color: color, fontSize: 12, margin: "10px 0" }}>
              {params.row.responseTransaction
                ? `(${params.row.responseTransaction.requestId}) - ${params.row.responseTransaction.status.message}`
                : ""}
            </b>
          );
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            wordWrap: params.value,
          });
        },
        // align: "center",
        flex: 1,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Creación",
        field: "createdAt",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return (
            <span>{Moment(params.value).format("DD-MM-YYYY HH:mm:ss")} </span>
          );
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 110,
        sortable: true,
        filtering: false,
        hideable: false,
      },
      /*...(UserAuth.profile_id === 1
        ? [
            {
              headerName: "---",
              field: "id",
              headerClassName: "super-app-theme--header",
              width: 100,
              headerAlign: "center",
              renderCell: (params) => {
                // Calculamos si la fecha `createdAt` está dentro de las últimas 24 horas
                const isRecent =
                  Moment().diff(Moment(params.row.createdAt), "hours") <= 24;

                // Comprobamos si el estatus es 1 y si la fecha está dentro de las últimas 24 horas
                const isButtonEnabled = isRecent && params.row.status === 1;

                return (
                  <ButtonTableGrid2
                    onClick={handleRefunded(params)}
                    style={{
                      margin: "12px 0",
                      padding: "5px 10px",
                      backgroundColor: isButtonEnabled ? "" : "#CACACA",
                      color: isButtonEnabled ? "" : "#F6F6F6",
                    }}
                    disabled={!isButtonEnabled} // El botón estará deshabilitado si no se cumple la condición
                  >
                    Reembolso
                  </ButtonTableGrid2>
                );
              },
              cellClassName: (params) => {
                return clsx("super-app", {
                  celAll: params.value,
                });
              },
              align: "center",
              sortable: false,
              filtering: false,
              hideable: false,
            },
          ]
        : [])*/
      ,
    ],
  });

  useEffect(() => {
    if (!props.open) return;

    setLoading(true);

    setTimeout(() => {
      const transformedRows = props.id.paymentTransactions.map((data) => ({
        ...data,
        responseTransaction: data.responseTransaction
          ? JSON.parse(data.responseTransaction)
          : null,
      }));

      setRows(transformedRows);
      setLoading(false);
    }, 1000);
  }, [props.open]);

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="md"
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        // style={{ zIndex: 100 }}
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Grid container>
            <Grid item xs={12} sm={12} md={12}>
              <div className={classes.cardTitleBlack}>
                <Payment className={classes.iconFilter} /> Transacciones
              </div>
              <Card>
                <CardContent>
                  <Fragment>
                    <Grid container>
                      <Grid item xs={12} sm={12}>
                        <Box
                          sx={{
                            "& .super-app.celAll": {
                              fontSize: 12,
                              //backgroundColor: 'rgba(255, 7, 0, 0.55)',
                            },
                            "& .super-app.celActions": {
                              backgroundColor: "rgb(242, 242, 242)",
                            },
                            "& .super-app-theme--header": {
                              backgroundColor: "rgb(242, 242, 242)",
                            },
                            marginTop: 2,
                          }}
                        >
                          <ThemeProvider theme={theme}>
                            <DataGrid
                              rows={rows}
                              columns={state.columns}
                              initialState={{
                                pagination: {
                                  paginationModel: { page: 0, pageSize: 10 },
                                },
                              }}
                              pageSizeOptions={[5, 10, 20, 50]}
                              disableRowSelectionOnClick={true}
                              checkboxSelection={false}
                              rowHeight={140}
                              sortModel={[
                                {
                                  field: "createdAt",
                                  sort: "desc",
                                },
                              ]}
                              sx={{
                                [`& .${gridClasses.cell}`]: {
                                  display: "flex",
                                  alignItems: "center", // Alineación vertical
                                  // justifyContent: 'center', // Alineación horizontal
                                  //wordWrap: 'break-word !important',
                                  //whiteSpace: 'normal !important',
                                },
                                /* [`& .${gridClasses.columnHeaderTitle}`]: {
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  justifyContent: 'center',
                                                },*/
                              }}
                              loading={loading}
                              getRowHeight={() => "auto"}
                              //autoHeights
                              autoWidth
                            />
                          </ThemeProvider>
                        </Box>
                      </Grid>
                    </Grid>
                  </Fragment>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          {/*openRefunded && (
            <RefundedPay
              open={openRefunded}
              id={rowId}
              exit={handleCloseRefunded}
            />
          )*/}
        </DialogContent>
        <DialogActions>
          <ButtonExit onClick={handleCloseDialog(true)}>Cerrar</ButtonExit>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
